export function scheduleCommentaryLabel(item) {
    const title = item.scheduleTitle ?? item.scheduleId
    return item.scheduleCode ? `${item.scheduleCode} ${title}` : title
}

export function scheduleCommentaryVersionLabel(item) {
    if (!item.scheduleCode || !item.scheduleVersion) return undefined
    return `#${item.scheduleCode} - Version ${item.scheduleVersion}`
}
